import ServerData from '../../data/server';

function getBaseUrl() {
  let { hostname } = window.location;
  hostname = hostname.replace("www.", "");
  let url = ServerData[hostname];
  if (url) return url;
  return ServerData.localhost;
}

export default {
  getBaseUrl,
};
